import React from 'react';
import { useUnits } from '@innovyze/stylovyze';
import { DiameterValue } from '@Types/riskConfig.types';
import { AttributeCell } from './AttributeCell';

interface DiameterCellProps {
	diameter?: DiameterValue | null;
}

// Raw value + schema unit from the API; the tenant's unit system decides the
// display (e.g. 300 mm or ~11.8 in).
export const DiameterCell = ({ diameter }: DiameterCellProps) => {
	const { getSystemValueFormatted } = useUnits();
	if (!diameter || !Number.isFinite(diameter.value)) {
		return <AttributeCell value={null} />;
	}
	const raw = `${diameter.value}${diameter.unit}`;
	return (
		<span>
			{getSystemValueFormatted(raw) ??
				`${diameter.value} ${diameter.unit}`}
		</span>
	);
};
